export function mergeArrays(array1, array2) {
  const mergedArray = [];

  const combinedArray = array1.concat(array2);

  const uniqueItemsMap = new Map();

  combinedArray.forEach(item => {
    const key = item.FieldNameOrGuid;

    if (!uniqueItemsMap.has(key)) {
      uniqueItemsMap.set(key, item);
    } else {
      const existingItem = uniqueItemsMap.get(key);
      existingItem.ascending = item.ascending;
    }
  });

  uniqueItemsMap.forEach(value => {
    mergedArray.push(value);
  });

  return mergedArray;
}

export function getFieldStringNameIfGuid(fieldNameOrGuid, isDisplayName = true) {
  const guidRegExp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  if (guidRegExp.test(fieldNameOrGuid)) {
    const field = this.fields.find(f => f.fieldGuid === fieldNameOrGuid);
    return isDisplayName ? field.displayName : field.name;
  }
  return fieldNameOrGuid;
}

export const camelCaseToString = (str) => {
  if(str === 'useSSL') return 'Use SSL';
  const words = str.split(/(?=[A-Z])/);
  return words
    .map(el => el.charAt(0).toUpperCase() + el.slice(1))
    .join(' ');
};


export const getEntryType = (label, entry) => {
  if(label === 'emailType') {
    return {element: 'select', options: ['smtp']};
  }

  if(label === 'logLevel') {
    return {
      element: 'select',
      options: ['Debug', 'Information'],
    };
  }

  if(label === 'username') {
    return {element: 'input', type: 'email'};
  }

  if(label === 'password') {
    return {element:'input', type: 'password'};
  }

  switch (typeof entry) {
  case 'object':
    return 'form';
  case 'boolean':
    return 'checkbox';
  case 'number':
    return {element:'input', type: 'number'};
  case 'string':
    return {element: 'input', type: 'text'};
  }
};

export const highlightText = (val, source) => {
  return val.length
    ? source.replace(
      new RegExp(`(${val})`, 'i'),
      '<span style="color:#ff1a09;">$1</span>',
    )
    : source;
};